// extracted by mini-css-extract-plugin
module.exports = {"root":"card_root__doCFz","MuiButton-label":"card_MuiButton-label__ZA-R6","icon":"card_icon__1xjwC"};